import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { t } from "i18next";
import { forwardRef, useImperativeHandle, useState } from "react";
import GlobalButton from "../../../components/CustomButton";

const buttonStyle = {
  height: 40,
  width: 100,
  borderRadius: 1,
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    maxWidth: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .close-icon-btn": {
    position: "absolute",
    top: "5px",
    right: "5px",
  },
}));

const AcceptAppointmentDialog = forwardRef(
  ({ handleAccepetAppointment }, ref) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openDialog(params) {
        setOpen(true);
      },
      closeDialog() {
        setOpen(false);
      },
    }));

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          variant="h1"
          fontWeight={500}
          fontSize={"1.5rem"}
          fontFamily={"inter"}
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
        >
          {t("confirmation")}
        </DialogTitle>

        <DialogContent dividers>
          <Typography
            variant="h5"
            textAlign={"center"}
            fontWeight={500}
            color={"custom.tartOrange"}
          >
            {t("confirmAcceptRequest")}
          </Typography>
        </DialogContent>

        <DialogActions sx={{ padding: "8px 18px" }}>
          <GlobalButton
            variant={"custom_outlined"}
            btnText={"close"}
            styleProps={buttonStyle}
            handleClickBtn={handleClose}
          />
          <GlobalButton
            variant={"contained"}
            btnText={"accept"}
            styleProps={buttonStyle}
            handleClickBtn={handleAccepetAppointment}
          />
        </DialogActions>
      </BootstrapDialog>
    );
  }
);

export default AcceptAppointmentDialog;
